// src/config.js

const baseURL =
  process.env.REACT_APP_API_BASE?.replace(/\/$/, "") ||
  "http://localhost:4000";

/* ---------------- API URLs ---------------- */

export const authURL = `${baseURL}/auth`;
export const membersURL = `${baseURL}/members`;
export const managersURL = `${baseURL}/managers`;
export const adminsURL = `${baseURL}/admins`;
export const oneOnOneURL = `${baseURL}/oneonones`;
export const teamsURL = `${baseURL}/teams`;
export const goalsURL = `${baseURL}/goals`;
export const feedbackURL = `${baseURL}/feedback`;
export const organizationsURL = `${baseURL}/organizations`;
export const atlassianURL = `${baseURL}/atlassian`;
export const zoomURL = `${baseURL}/zoom`;
export const slackURL = `${baseURL}/slack`;
export const aiURL = `${baseURL}/ai`;
export const decisionsURL = `${baseURL}/decision`;

/* ---------------- Axios helpers ---------------- */

/**
 * Normalize axios errors for UI usage.
 * NOTE: 401 handling is done globally in apiClient.
 */
export function formatAxiosError(err, prefix = "Request failed") {
  if (!err) return new Error(prefix);

  const resp = err.response;

  if (resp?.data) {
    const msg =
      typeof resp.data === "string"
        ? resp.data
        : resp.data.message || JSON.stringify(resp.data);

    return new Error(`${prefix}: ${msg}`);
  }

  return new Error(`${prefix}: ${err.message || "Unknown error"}`);
}

/**
 * Convenience unwrap helper
 */
export const unwrap = (res) => res.data;
